import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/blocks/PageHero';
import { MediaCard } from '../components/blocks/MediaCard';
import { CtaBanner } from '../components/blocks/CtaBanner';
import { SectionHeading } from '../components/blocks/SectionHeading';
import { SectionDivider, SURFACE } from '../components/blocks/SectionDivider';
import { useSeo } from '../lib/useSeo';
import { audioVideoSchema } from '../lib/schema';
import { SITE } from '../lib/siteConfig';

/**
 * PAGE: /podcasts
 * WORDPRESS: page template `page-podcasts.php`
 *
 * Blocks: hero → intro_statement → media_card (panel) → cta_banner
 */

const HERO_IMAGE = 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&q=80&w=2000';
const PODCAST_COVER = 'https://milangelassoulgarden.com/wp-content/uploads/2022/07/01-MILANGELA-01.png';
const SPOTIFY_URL = 'https://creators.spotify.com/pod/profile/milangela/';
export function Podcasts() {
  useSeo({
    title: 'Podcasts',
    description: 'Conversations on wellbeing, personal growth, nature, awareness and everyday life — a quiet companion for your journey, on Spotify.',
    path: '/podcasts',
    image: HERO_IMAGE,
    breadcrumbs: [{
      name: 'Podcasts',
      path: '/podcasts'
    }],
    schema: [audioVideoSchema({
      type: 'PodcastSeries',
      name: `${SITE.name} Podcast`,
      description: 'Reflections and conversations on wellbeing, creativity, nature and spirituality with Branka Androjna.',
      path: '/podcasts',
      image: PODCAST_COVER,
      externalUrl: SPOTIFY_URL
    })]
  });
  return <div className="min-h-screen bg-cream" data-id="element-572" data-mp="2qemrpa4ezdon">
      <Header data-id="element-573" data-mp="2qewhoxpglkuc" />

      <main data-id="element-574" data-mp="2qf664guuvjxx">
        <PageHero eyebrow="The Garden" heading="Podcasts" subheading="Conversations that stay with you." body="Sometimes a single conversation can shift the way we see ourselves and the world around us." image={HERO_IMAGE} imageAlt="Sunlit wildflowers in a peaceful garden" dividerFill={SURFACE.cream} data-id="element-575" data-mp="2qgqs3i33tuk6" />

        <section className="bg-cream px-6 py-20 md:py-28" data-id="element-576" data-mp="213i04mbpmrrd">
          <div className="mx-auto max-w-3xl text-center" data-id="element-577" data-mp="262350z1wpzm5">
            <p className="text-xs font-medium tracking-[0.26em] text-sage-700 uppercase" data-id="element-578" data-mp="260ia38bokenr">
              Stories to return to
            </p>
            <div className="mt-6 space-y-5 font-serif text-2xl leading-snug text-charcoal sm:text-3xl" data-id="element-579" data-mp="2fr32ge0rgmy8">
              <p data-id="element-580" data-mp="2kq6be9jv3dbh">
                These episodes explore wellbeing, personal growth, nature,
                awareness and everyday life — offering inspiration you can
                return to whenever you need a quiet companion on your journey.
              </p>
              <p className="italic text-sage-700" data-id="element-581" data-mp="uf1m6pvvjc37">
                Listen whenever you need a different perspective or simply a
                moment for yourself.
              </p>
            </div>
          </div>
        </section>

        <SectionDivider from={SURFACE.cream} to={SURFACE.creamDeep} data-id="element-582" data-mp="rvf0k00toc17" />

        <section className="bg-cream-200 px-6 pb-24 pt-8 md:pb-28" data-id="element-583" data-mp="n3wyf8n2c5en">
          <div className="mx-auto max-w-5xl" data-id="element-584" data-mp="n1kcyli3jcwu">
            <SectionHeading eyebrow="Listen on Spotify" heading={SITE.name} align="center" accent="rose" className="mb-12" data-id="element-585" data-mp="i3slfsld5st6" />
            <MediaCard layout="panel" eyebrow="Podcast series" title="Conversations for the path back to yourself." description="Follow Milangela's reflections and conversations on wellbeing, creativity, nature and spirituality." thumbnail={PODCAST_COVER} thumbnailAlt={`${SITE.name} podcast cover`} url={SPOTIFY_URL} linkLabel="Open podcast on Spotify" data-id="element-586" data-mp="1as6ju9gd6r59" />
          </div>
        </section>

        <CtaBanner heading="Ready to take the next step?" buttonLabel="Start Your Journey" buttonTo="/start-your-journey" dividerFrom={SURFACE.creamDeep} data-id="element-587" data-mp="3hiw46y6vj3tv" />
      </main>

      <Footer data-id="element-588" data-mp="1e30q08vb42ss" />
    </div>;
}